import React from 'react';
import { PlayCircleIcon, CheckCircleIcon } from 'lucide-react';
const Hero = () => {
  return <section className="pt-32 pb-16 md:pt-40 md:pb-24 bg-subtle-gradient overflow-hidden" data-id="element-94">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="flex flex-col md:flex-row items-center" data-id="element-96">
          {/* Text Content - 60% */}
          <div className="w-full md:w-3/5 mb-10 md:mb-0 md:pr-12" data-id="element-97">
            <h1 className="font-outfit font-bold text-4xl md:text-5xl lg:text-6xl leading-tight text-charcoal mb-6" data-id="element-98">
              Pay all your bills instantly, settle once monthly
            </h1>
            <p className="text-lg md:text-xl text-slate-grey mb-8 max-w-2xl" data-id="element-99">
              Settl automates bill payments for Malaysian SMEs, giving you 30
              days to pay us back. Save time, improve cash flow, and never miss
              a payment again.
            </p>
            {/* Trust Badges */}
            <div className="flex flex-wrap items-center gap-6 mb-10" data-id="element-100">
              <div className="flex items-center" data-id="element-101">
                <CheckCircleIcon className="h-5 w-5 text-success-green mr-2" data-id="element-102" />
                <span className="text-sm font-medium" data-id="element-103">
                  Trusted by 500+ SMEs
                </span>
              </div>
              <div className="flex items-center" data-id="element-104">
                <CheckCircleIcon className="h-5 w-5 text-success-green mr-2" data-id="element-105" />
                <span className="text-sm font-medium" data-id="element-106">Bank-level security</span>
              </div>
              <div className="flex items-center" data-id="element-107">
                <CheckCircleIcon className="h-5 w-5 text-success-green mr-2" data-id="element-108" />
                <span className="text-sm font-medium" data-id="element-109">No hidden fees</span>
              </div>
            </div>
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-110">
              <a href="https://wa.me/60127743934/?text=I%20am%20interested%20in%20Settl" className="btn-primary" data-id="element-111">
                Start Free Trial
              </a>
              <a href="https://wa.me/60127743934/?text=I%20am%20interested%20in%20Settl" className="btn-secondary flex items-center justify-center gap-2" data-id="element-112">
                <PlayCircleIcon className="h-5 w-5" data-id="element-113" />
                Watch Demo
              </a>
            </div>
          </div>
          {/* Hero Image - 40% */}
          <div className="w-full md:w-2/5 relative" data-id="element-114">
            <div className="relative bg-white rounded-2xl shadow-lg p-6 z-10" data-id="element-115">
              <div className="absolute -top-3 -right-3 bg-success-green text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-116">
                AUTOMATED
              </div>
              <h3 className="font-medium text-lg mb-4" data-id="element-117">Monthly Bill Summary</h3>
              <div className="space-y-3" data-id="element-118">
                {[{
                vendor: 'Office Rental',
                amount: 'RM 5,200',
                status: 'Paid'
              }, {
                vendor: 'Internet Provider',
                amount: 'RM 899',
                status: 'Paid'
              }, {
                vendor: 'Electricity',
                amount: 'RM 1,245',
                status: 'Paid'
              }, {
                vendor: 'Software Subscriptions',
                amount: 'RM 3,450',
                status: 'Paid'
              }].map((bill, index) => <div key={index} className="flex justify-between items-center p-3 bg-light-sky rounded-lg" data-id="element-119">
                    <span data-id="element-120">{bill.vendor}</span>
                    <div className="flex items-center gap-3" data-id="element-121">
                      <span className="font-space-mono" data-id="element-122">{bill.amount}</span>
                      <span className="text-xs bg-success-green bg-opacity-10 text-success-green px-2 py-1 rounded-full" data-id="element-123">
                        {bill.status}
                      </span>
                    </div>
                  </div>)}
              </div>
              <div className="mt-4 pt-4 border-t border-gray-100 flex justify-between items-center" data-id="element-124">
                <span className="font-medium" data-id="element-125">Total Due to Settl</span>
                <span className="font-space-mono font-bold text-xl" data-id="element-126">
                  RM 10,794
                </span>
              </div>
              <div className="mt-3 text-xs text-slate-grey" data-id="element-127">
                Due in 30 days: 15 June 2023
              </div>
            </div>
            {/* Floating Elements */}
            <div className="absolute -top-6 -left-6 bg-settl-blue text-white p-3 rounded-lg shadow-lg transform -rotate-6 z-0" data-id="element-128">
              <div className="font-space-mono text-sm" data-id="element-129">Invoice #1234</div>
            </div>
            <div className="absolute -bottom-4 -right-4 bg-white p-3 rounded-lg shadow-lg transform rotate-6 z-0" data-id="element-130">
              <div className="font-space-mono text-sm text-success-green" data-id="element-131">
                +30 Days
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;